module.exports = __webpack_public_path__ + "img/Logo_iNoe_512px.a9b7bcf3.png";